/**
 * Handles updating an image by URL (with "cover" style centering/scaling).
 *
 * @param url - The direct URL to the image (e.g. "https://example.com/my-image.png").
 * @param key - Unique identifier for this image input in your template.
 */
import {ImageInput} from "../models/Template";

export const handleImageChangeByUrl = (url: string, imageInput: ImageInput, element: HTMLImageElement, designKey: string) => {
    if (!url) return;

    // Create a new Image object to measure its natural dimensions
    const newImg = new Image();
    newImg.src = url;

    // Once the image loads, we have access to its natural dimensions
    newImg.onload = () => {
        const assetWidth = newImg.naturalWidth;
        const assetHeight = newImg.naturalHeight;

        const imageInputWidth = imageInput.size?.[designKey]?.width;
        const imageInputHeight = imageInput.size?.[designKey]?.height;
        // Ensure we only do scaling if we have a defined bounding box
        if (imageInputWidth && imageInputHeight && assetWidth && assetHeight) {
            const {
                width,
                height,
                left,
                top
            } = handleImageChangeByWidthAndHeight(imageInputWidth, imageInputHeight, assetWidth, assetHeight)

            // Apply inline styles for absolute positioning and size
            element.style.position = 'relative';
            element.style.width = `${width}px`;
            element.style.height = `${height}px`;
            element.style.left = `${left}px`;
            element.style.top = `${top}px`;
        }

        // Handle any potential loading errors
        newImg.onerror = (err) => {
            console.error('Failed to load image from URL:', err);
        };
    }
}


export const handleImageChangeByWidthAndHeight = (imageInputWidth: number, imageInputHeight: number, assetWidth: number, assetHeight: number,) => {
    // Get the aspect ratios for the bounding box and the asset
    const boundingAspectRatio = imageInputWidth / imageInputHeight;
    const imageAspectRatio = assetWidth / assetHeight;

    // Decide whether to scale to match width or height
    let scale = 1;
    if (imageAspectRatio > boundingAspectRatio) {
        // If the image is “wider,” match the bounding box’s height
        scale = imageInputHeight / assetHeight;
    } else {
        // Otherwise, match the bounding box’s width
        scale = imageInputWidth / assetWidth;
    }

    // Calculate final dimensions
    const width = assetWidth * scale;
    const height = assetHeight * scale;
    const left = (imageInputWidth - width) / 2;
    const top = (imageInputHeight - height) / 2;

    return {
        width,
        height,
        left,
        top
    }
}

export const getWidthAndHeightAccordingToRotation = (element: HTMLElement, width: number, height: number) => {
    if (element.style.transform && element.style.transform.includes("rotate")) {
        const match1 = element.style.transform.match(/rotate\(-?(\d+(\.\d+)?)deg\)/);
        if (match1 && (match1[1] == "90" || match1[1] == "270")) {
            return {height, width}
        }
    }
    return {width, height}
}

